
import Vue from 'vue'
export default Vue.extend({
   name: 'DeleteButton',
   props: {
      label: { default: 'Delete', type: String },
      actionLabel: { default: 'Deleting', type: String },
      showIcon: { default: false, type: Boolean },
      icon: { default: 'glyphicon-trash', type: String },
      bold: { default: false, type: Boolean },
      size: { default: '', type: String },
      enabled: { default: true, type: Boolean },
      deleting: { default: false, type: Boolean },
      prompt: { default: true, type: Boolean },
      promptText: { default: 'Are you sure?', type: String },
      confirmPrompt: { default: false, type: Boolean },
   },
   computed: {
      currentLabel(): string {
         return this.deleting ? this.actionLabel : this.label
      },
      localePromptText(): string {
         return this.$t(this.promptText) as string
      },

      localeConfirmText(): string {
         return this.$t('DELETE') as string
      },

      localeConfirmPrompt(): string {
         return this.$t(
            `To confirm you really want to do this, type ${this.localeConfirmText} below.`
         ) as string
      },

      buttonClass(): string {
         if (this.bold) {
            return 'btn btn-danger'
         } else {
            return 'btn btn-link'
         }
      },

      textClass(): string {
         if (this.bold) {
            return ''
         } else {
            return 'text-danger'
         }
      },
   },
   methods: {
      onClick() {
         if (!this.enabled || this.deleting) {
            return
         }

         if (!this.prompt) {
            this.$emit('click')
         }
         if (this.confirmPrompt) {
            const promptText = `${this.localePromptText}\r\n${this.localeConfirmPrompt}`
            const confirm = prompt(promptText)
            if (confirm && confirm.trim() === this.localeConfirmText) {
               this.$emit('click')
            }
         } else {
            const confirmed = confirm(this.localePromptText as string)
            if (confirmed) {
               this.$emit('click')
            }
         }
      },
   },
})
